import Intercom, { hide, showConversation, showMessages, showNewMessage, shutdown } from '@intercom/messenger-js-sdk';

import { CurrentUser } from '../axios';

// Opens the Intercom messenger with the composer preloaded with `message`.
// Best-effort: returns true if the messenger was invoked, false if Intercom is
// unavailable (not booted, blocked). Callers use the result for the support
// handoff fallback so a failed open never loses the user's message.
export const openIntercom = (message?: string): boolean => {
  try {
    showNewMessage(message || '');
    return true;
  } catch (e) {
    console.error('Failed to open Intercom', e);
    return false;
  }
};

// Opens the Intercom messenger to the user's conversation list. Used first in
// the support handoff (before the thread has synced) so the user lands in their
// inbox with no spinner while the just-sent conversation appears.
// Best-effort: returns false if Intercom is unavailable.
export const openIntercomInbox = (): boolean => {
  try {
    showMessages();
    return true;
  } catch (e) {
    console.error('Failed to open Intercom messages', e);
    return false;
  }
};

// Opens an existing Intercom conversation by id. Only reliable once the
// messenger has synced the conversation (a REST-created conversation is not in
// the messenger cache immediately — deep-linking too early hangs on a spinner),
// so callers open it after a short delay or on an explicit user click.
export const openIntercomConversation = (conversationId: string): boolean => {
  try {
    showConversation(conversationId);
    return true;
  } catch (e) {
    console.error('Failed to open Intercom conversation', e);
    return false;
  }
};

export const closeIntercom = () => {
  hide();
};

export const shutdownIntercom = () => {
  shutdown();
};

export const initializeIntercomWithUser = (currentUser: CurrentUser) => {
  Intercom({
    app_id: process.env.NODE_ENV === 'production' ? 'xxw0e0bv' : 'cji4j4b4',
    user_hash: currentUser?.intercom_user_hash,
    user_id: currentUser?.id?.toString(),
    name: currentUser?.username ? `${currentUser?.username} (${currentUser?.last_name})` : '',
    email: currentUser?.email,
    language: currentUser?.lang,
    is_admin: currentUser?.is_admin,
    phone: currentUser?.phone,
    company: {
      id: currentUser?.company_id,
      name: currentUser?.company_name,
    },
    z_index: 100,
  });
};

export const initializeIncognitoIntercom = () => {
  Intercom({
    app_id: process.env.NODE_ENV === 'production' ? 'xxw0e0bv' : 'cji4j4b4',
    z_index: 100,
  });
};
